{
  "fr": {
    "locale_field": {
      "fallback_tooltip": "Lorsqu'aucun texte n'est saisi pour cette langue, ce texte par défaut sera utilisé comme solution de repli.",
      "translated_in": "Traduit en"
    }
  }
}
